/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FACILITY_HAS_A_SYSTEM_FOR_IDENTIFYING_EVALUATING_AND_MINIMIZING',
              'WORKERS_ARE_ROTATED_TO_REDUCE_EXPOSURE_TO_REPETITIVE_TASKS',
              'WORKERS_CAN_TAKE_SHORT_ERGONOMIC_BREAKS_DURING_THE_WORK_DAY',
              'FACILITY_PROVIDES_ADJUSTABLE_WORKSTATIONS_TO_ACCOMMODATE_INDIVI',
              'FACILITY_PROVIDES_ADJUSTABLE_EQUIPMENT_TO_ACCOMMODATE_INDIVIDUA',
              'FACILITY_PROVIDES_TRAINING_ON_ERGONOMIC_FACTORS_AND_GOOD_PRACTI',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_9: valueSchema,
  },
}
